import { toString, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ofArray, tail, head, isEmpty, toArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { RouterModule_nav, RouterModule_urlSegments } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { append, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Tab, Tabs, Typography } from "@mui/material";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { View as View_1 } from "./DashboardTickets.js";
import { View as View_2 } from "./DashboardActivities.js";
import { View as View_3 } from "./DashboardUserActivity.js";
import { View as View_4 } from "./DashboardCriticalOperationalHalts.js";

class DashboardView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CriticalOperationalHalts", "Tickets", "UserActivity", "Activities"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "tickets" : ((this$.tag === 2) ? "user-activity" : ((this$.tag === 3) ? "activities" : "coh"));
    }
}

function DashboardView_$reflection() {
    return union_type("Kundeweb.Dashboards.DashboardView", [], DashboardView, () => [[], [], [], []]);
}

function DashboardView__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 3:
            return 2;
        case 2:
            return 3;
        default:
            return 0;
    }
}

function DashboardView_FromInt_Z524259A4(x) {
    switch (x) {
        case 1:
            return new DashboardView(1, []);
        case 2:
            return new DashboardView(3, []);
        case 3:
            return new DashboardView(2, []);
        default:
            return new DashboardView(0, []);
    }
}

function DashboardView_FromPath_7F866359(path) {
    console.debug("[AdminDashboard] Current url", toArray(path));
    let matchResult;
    if (!isEmpty(path)) {
        if (head(path) === "admin") {
            if (!isEmpty(tail(path))) {
                if (head(tail(path)) === "dashboard") {
                    if (!isEmpty(tail(tail(path)))) {
                        switch (head(tail(tail(path)))) {
                            case "tickets": {
                                if (isEmpty(tail(tail(tail(path))))) {
                                    matchResult = 0;
                                }
                                else {
                                    matchResult = 4;
                                }
                                break;
                            }
                            case "activities": {
                                matchResult = 1;
                                break;
                            }
                            case "user-activity": {
                                if (isEmpty(tail(tail(tail(path))))) {
                                    matchResult = 2;
                                }
                                else {
                                    matchResult = 4;
                                }
                                break;
                            }
                            case "coh": {
                                matchResult = 3;
                                break;
                            }
                            default:
                                matchResult = 4;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                }
                else {
                    matchResult = 4;
                }
            }
            else {
                matchResult = 4;
            }
        }
        else {
            matchResult = 4;
        }
    }
    else {
        matchResult = 4;
    }
    switch (matchResult) {
        case 0:
            return new DashboardView(1, []);
        case 1:
            return new DashboardView(3, []);
        case 2:
            return new DashboardView(2, []);
        case 3:
            return new DashboardView(0, []);
        default:
            return undefined;
    }
}

export function View() {
    const ctx = reactApi.useContext(ctx_1);
    const headerRef = reactApi.useRef(undefined);
    const headerHeight = defaultArg(map((arg) => ~~arg.clientHeight, headerRef.current), 120) | 0;
    const currentView = DashboardView_FromPath_7F866359(RouterModule_urlSegments(window.location.hash, 1));
    const xs_4 = toList(delay(() => {
        let elems_1, elements;
        const matchValue = ctx.Session;
        let matchResult, s_1;
        if (matchValue != null) {
            if (!matchValue.IsAdmin) {
                matchResult = 0;
                s_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", "Du har ikke tilgang til denne siden"]]));
            default: {
                const matchValue_1 = currentView;
                if (matchValue_1 != null) {
                    const view = matchValue_1;
                    return append(singleton(createElement("div", createObj(ofArray([["ref", headerRef], ["style", {
                        paddingLeft: 10,
                        paddingBottom: 10,
                    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", "Dashboard"]]), MuiHelpers_createElement(Tabs, [["centered", false], ["value", DashboardView__get_Id(view)], ["onChange", (_arg_1, v) => {
                        const i = v | 0;
                        const newView = DashboardView_FromInt_Z524259A4(i);
                        console.debug("[AdminDashboard] on tab change", i, newView);
                        RouterModule_nav(ofArray(["admin", "dashboard", toString(newView)]), 1, 1);
                    }], ["variant", "standard"], ["indicatorColor", "primary"], ["textColor", "primary"], (elements = [MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("Dashboard.CriticalOperationalHalts.CriticalOperationalHalts")]]), MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("Pages.Tickets")]]), MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("Dashboard.Activities.Activities")]]), MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("Dashboard.Usage.UserUsage")]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                        let elems_3, elems_2;
                        return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container"])], ["style", {
                            height: ("calc(" + (`100vh - 120px - 60px - ${headerHeight}px`)) + ")",
                        }], (elems_3 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner"])], (elems_2 = toList(delay(() => ((view.tag === 1) ? singleton(createElement(View_1, null)) : ((view.tag === 3) ? singleton(createElement(View_2, null)) : ((view.tag === 2) ? singleton(createElement(View_3, null)) : singleton(createElement(View_4, null))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                    }));
                }
                else {
                    return singleton(createElement("h2", {
                        children: ["This should not happen"],
                    }));
                }
            }
        }
    }));
    return react.createElement(react.Fragment, {}, ...xs_4);
}

